import { useEffect } from 'react';

/** Tell parent iframe (embed.js) to resize to content height. */
export default function EmbedAutoHeight({ widgetId }) {
  useEffect(() => {
    if (!widgetId || typeof window === 'undefined' || window.parent === window) return;

    const post = () => {
      const height = Math.ceil(document.documentElement.scrollHeight);
      window.parent.postMessage(
        { type: 'scorewidget:resize', widgetId, height },
        '*'
      );
    };

    post();
    const t = window.setTimeout(post, 400);
    const ro = new ResizeObserver(() => post());
    ro.observe(document.documentElement);

    return () => {
      window.clearTimeout(t);
      ro.disconnect();
    };
  }, [widgetId]);

  return null;
}
